import React from 'react';

import styles from './divider.module.scss';

export default function Divider(){
    return (
        <div className={styles.divider}></div>
    );
}
